import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-291097f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "video-wrap",
  class: "active"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "video-overlay" }, null, -1))
const _hoisted_3 = { class: "video-container" }
const _hoisted_4 = {
  key: 0,
  src: "https://player.vimeo.com/video/644945961?autoplay=1",
  frameborder: "0",
  allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
  allowfullscreen: "true"
}

import { useStore } from 'vuex';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const isVideoModal = computed(() => store.getters.isVideoModalStatus);
const closeVideo = () => store.commit('SET_VIDEO_PLAYER');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_unref(isVideoModal))
        ? (_openBlock(), _createElementBlock("iframe", _hoisted_4))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("button", {
      class: "close-video",
      onClick: closeVideo
    })
  ]))
}
}

})